class CartCrossSell extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    const url = this.dataset.recommendationsUrl;
    if (!productId || !url) return;

    const limit = this.dataset.limit || 4;

    fetch(`${url}?product_id=${productId}&limit=${limit}&intent=related`)
      .then((response) => response.json())
      .then((data) => this.renderProducts(data.products || []))
      .catch((e) => {
        console.error('cart-cross-sell', e);
      });
  }

  renderProducts(products) {
    const list = this.querySelector('.cart-cross-sell__list');
    if (!list) return;

    if (!products.length) {
      this.remove();
      return;
    }

    const limit = parseInt(this.dataset.limit, 10) || 4;

    list.innerHTML = products
      .slice(0, limit)
      .map((product) => this.renderCard(product))
      .join('');
  }

  renderCard(product) {
    const variant = product.variants && product.variants[0];
    const image = product.featured_image || (product.images && product.images[0]);
    const price = variant ? this.formatMoney(variant.price) : '';
    const title = this.escapeHtml(product.title);

    return `
      <div class="cart-cross-sell__item" role="listitem">
        <a href="${product.url}" class="cart-cross-sell__image-link">
          ${
            image
              ? `<img src="${image}" alt="${title}" loading="lazy" width="120" height="120" class="cart-cross-sell__image">`
              : ''
          }
        </a>
        <div class="cart-cross-sell__info">
          <a href="${product.url}" class="cart-cross-sell__title">${title}</a>
          <span class="cart-cross-sell__price">${price}</span>
        </div>
        ${
          variant && variant.available
            ? `<form action="/cart/add" method="post" class="cart-cross-sell__form">
                <input type="hidden" name="id" value="${variant.id}">
                <input type="hidden" name="return_to" value="/cart">
                <button type="submit" class="cart-cross-sell__add button button--tertiary" aria-label="In den Warenkorb legen: ${title}">+</button>
              </form>`
            : ''
        }
      </div>
    `;
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }
}

customElements.define('cart-cross-sell', CartCrossSell);
